// src/components/Footer.jsx
import { MAIN_ORIGIN, FORUM_ORIGIN, MINECRAFT_ORIGIN, STORE_ORIGIN } from "../utils/siteUrls";

const DISCORD_URL = "https://discord.gg/AzrauJnuqw";
const YOUTUBE_URL = "https://www.youtube.com/@TheOnesAboveMedia";
const INSTAGRAM_URL = "https://instagram.com/TheOnesAboveMedia";

const YT_SVG = (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="#ff3333" aria-hidden="true">
    <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1C24 15.9 24 12 24 12s0-3.9-.5-5.8zM9.7 15.5V8.5l6.3 3.5-6.3 3.5z" />
  </svg>
);

const IG_SVG = (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="url(#ig-footer)" aria-hidden="true">
    <defs>
      <linearGradient id="ig-footer" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#f09433" />
        <stop offset="25%" stopColor="#e6683c" />
        <stop offset="50%" stopColor="#dc2743" />
        <stop offset="75%" stopColor="#cc2366" />
        <stop offset="100%" stopColor="#bc1888" />
      </linearGradient>
    </defs>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
  </svg>
);

const DISCORD_SVG = (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="#5865F2" aria-hidden="true">
    <path d="M20.317 4.3698A19.7913 19.7913 0 0 0 15.8854 3c-.1911.3433-.4033.8057-.5538 1.1695a18.27 18.27 0 0 0-5.6592 0A12.64 12.64 0 0 0 9.1067 3a19.7368 19.7368 0 0 0-4.432 1.3698C1.873 8.5305 1.1132 12.5881 1.4901 16.5867a19.9907 19.9907 0 0 0 5.4257 2.7264 14.75 14.75 0 0 0 1.302-2.1166 12.91 12.91 0 0 1-2.0508-.9915c.172-.126.3402-.2567.5033-.3911 3.9551 1.8208 8.2475 1.8208 12.155 0 .1642.1344.3324.2651.5033.3911a12.9 12.9 0 0 1-2.0543.9926 14.63 14.63 0 0 0 1.302 2.1155 19.963 19.963 0 0 0 5.4257-2.7264c.4432-4.6388-.757-8.6596-3.684-12.2169ZM8.02 14.1535c-1.1879 0-2.1643-1.0989-2.1643-2.4486 0-1.3497.9556-2.4497 2.1643-2.4497 1.2174 0 2.1851 1.1096 2.1643 2.4497 0 1.3497-.9556 2.4486-2.1643 2.4486Zm7.9748 0c-1.188 0-2.1643-1.0989-2.1643-2.4486 0-1.3497.9556-2.4497 2.1643-2.4497 1.2174 0 2.1851 1.1096 2.1643 2.4497 0 1.3497-.9469 2.4486-2.1643 2.4486Z" />
  </svg>
);

const footerGroups = [
  {
    title: "Explore",
    links: [
      { label: "Home", href: `${MAIN_ORIGIN}/` },
      { label: "TOA Apparel", href: `${STORE_ORIGIN}/` },
    ],
  },
  {
    title: "Minecraft",
    links: [
      { label: "Server Overview", href: `${MINECRAFT_ORIGIN}/` },
      { label: "Mods", href: `${MINECRAFT_ORIGIN}/mods` },
      { label: "TOA RP Store", href: `${MINECRAFT_ORIGIN}/store` },
    ],
  },
  {
    title: "Community",
    links: [
      { label: "Forums", href: `${FORUM_ORIGIN}/` },
      { label: "Charity Fund", href: `${MAIN_ORIGIN}/charity-fund` },
      { label: "Discord", href: DISCORD_URL, external: true },
    ],
  },
];

export default function Footer() {
  return (
    <>
      <style>{`
        .toa-footer{
          position:relative!important;
          z-index:50!important;
          width:100%!important;
          box-sizing:border-box!important;
          background:#050508!important;
          border-top:1px solid var(--border)!important;
          padding:44px 24px 24px!important;
        }

        /* Keep the footer background full-width, but constrain the CONTENT again. */
        .toa-footer .toa-foot{
          width:100%!important;
          max-width:1240px!important;
          margin:0 auto!important;
        }

        .toa-footer .toa-ftop{
          display:grid!important;
          grid-template-columns:minmax(280px,1.45fr) minmax(0,2.55fr)!important;
          gap:64px!important;
          align-items:start!important;
          margin:0 0 30px!important;
          padding:0 0 30px!important;
          border-bottom:1px solid var(--border)!important;
        }

        .toa-footer-brand{max-width:470px}

        .toa-footer-link-grid{
          display:grid;
          grid-template-columns:repeat(3,minmax(140px,1fr));
          gap:36px;
          width:100%;
        }

        .toa-footer-group{min-width:0}
        .toa-footer .toa-fbd{max-width:450px;margin:0}
        .toa-footer .toa-flinks{margin:0!important;padding:0!important;list-style:none!important}
        .toa-footer .toa-flinks li{margin:0!important;padding:0!important}
        .toa-footer .toa-fbot{display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap}
        .toa-footer .toa-fsoc{display:flex;align-items:center;gap:8px}

        .toa-footer .toa-fsb{
          width:34px;
          height:34px;
          border-radius:7px;
          background:var(--card);
          border:1px solid var(--border);
          display:flex;
          align-items:center;
          justify-content:center;
          text-decoration:none;
          transition:.15s;
        }

        .toa-footer .toa-fsb:hover{
          border-color:var(--borderB);
          transform:translateY(-2px);
        }

        @media(max-width:1000px){
          .toa-footer{padding:40px 22px 22px!important}
          .toa-footer .toa-ftop{
            grid-template-columns:1fr!important;
            gap:26px!important;
          }
          .toa-footer-link-grid{
            grid-template-columns:repeat(3,minmax(0,1fr));
            gap:22px;
          }
          .toa-footer-brand{max-width:600px}
        }

        @media(max-width:600px){
          .toa-footer{padding:30px 14px 16px!important}
          .toa-footer .toa-ftop{
            grid-template-columns:1fr!important;
            gap:20px!important;
            margin-bottom:18px!important;
            padding-bottom:20px!important;
          }
          .toa-footer-link-grid{
            grid-template-columns:repeat(3,minmax(0,1fr))!important;
            gap:10px!important;
          }
          .toa-footer .toa-fct{
            font-size:9.5px!important;
            letter-spacing:1px!important;
            margin-bottom:8px!important;
            white-space:nowrap;
          }
          .toa-footer .toa-flinks{gap:5px!important}
          .toa-footer .toa-flinks a{
            font-size:10.5px!important;
            line-height:1.35!important;
            overflow-wrap:anywhere;
          }
          .toa-footer .toa-fbn{font-size:17px!important}
          .toa-footer .toa-fbs{font-size:10px!important;letter-spacing:1.4px!important}
          .toa-footer .toa-fbd{font-size:11.5px!important;line-height:1.6!important}
          .toa-footer .toa-fbot{align-items:flex-start!important;gap:12px!important}
          .toa-footer .toa-fcopy{font-size:10px!important;line-height:1.5!important;max-width:70%}
          .toa-footer .toa-fsb{width:31px;height:31px}
        }

        @media(max-width:380px){
          .toa-footer-link-grid{gap:7px!important}
          .toa-footer .toa-fct{font-size:9px!important;letter-spacing:.7px!important}
          .toa-footer .toa-flinks a{font-size:9.8px!important}
          .toa-footer .toa-fcopy{max-width:64%}
        }
      `}</style>

      <footer className="toa-footer">
        <div className="toa-foot">
          <div className="toa-ftop">
            <div className="toa-footer-brand">
              <div className="toa-fbn">The Ones Above</div>
              <div className="toa-fbs">Rise Above. Grow Together.</div>
              <p className="toa-fbd">
                A community built around faith, growth, creativity and positive impact — online,
                in Minecraft, and beyond.
              </p>
            </div>

            <div className="toa-footer-link-grid">
              {footerGroups.map(({ title, links }) => (
                <div className="toa-footer-group" key={title}>
                  <div className="toa-fct">{title}</div>
                  <ul className="toa-flinks">
                    {links.map(({ label, href, external }) => (
                      <li key={label}>
                        <a
                          href={href}
                          target={external ? "_blank" : undefined}
                          rel={external ? "noreferrer" : undefined}
                        >
                          {label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="toa-fbot">
            <div className="toa-fcopy">
              © {new Date().getFullYear()} <span>The Ones Above</span> · All rights reserved · <span>theonesabove.com</span>
            </div>

            <div className="toa-fsoc" aria-label="Social media links">
              <a
                href={YOUTUBE_URL}
                target="_blank"
                rel="noreferrer"
                className="toa-fsb"
                title="YouTube"
                aria-label="YouTube"
              >
                {YT_SVG}
              </a>
              <a
                href={DISCORD_URL}
                target="_blank"
                rel="noreferrer"
                className="toa-fsb"
                title="Discord"
                aria-label="Discord"
              >
                {DISCORD_SVG}
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noreferrer"
                className="toa-fsb"
                title="Instagram"
                aria-label="Instagram"
              >
                {IG_SVG}
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
